import React from 'react';
import { Route, Switch } from 'react-router';
import Layout from 'components/Layout';
import List from './List';
import Form from './Form';

const Event = () => (
  <Layout>
    <Switch>
      <Route exact path="/events" component={List} />
      <Route exact path="/events/new" component={Form} />
      <Route exact path="/events/:id" component={Form} />
    </Switch>
  </Layout>
);

export default Event;
